module.exports = __webpack_public_path__ + "static/media/circle-growth.1ff8849e.gif";